<template>
    <div class="workAge">
        <div class="title AkrobatM">
            {{ $t('ca.第count周训练', { count: currentWeek }) }}
            <div class="page_btn">
                <div class="btn">
                    <el-button
                        class="noBorder"
                        icon="el-icon-arrow-left"
                        circle
                        :disabled="currentWeek === 1"
                        @click="pageFun('prev')"
                        :style="{ opacity: currentWeek === 1 ? 0.5 : 1 }"
                    ></el-button>
                </div>
                <div class="btn">
                    <el-button
                        class="noBorder"
                        icon="el-icon-arrow-right"
                        circle
                        :disabled="currentWeek * weekDays >= totalDay"
                        :style="{ opacity: currentWeek * weekDays >= totalDay ? 0.5 : 1 }"
                        @click="pageFun('next')"
                    ></el-button>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="day_title_list">
                <div v-for="(itemDay, index) in weekDays" :key="itemDay" class="day_title">
                    <div v-if="(currentWeek - 1) * weekDays + index + 1 <= totalDay">
                        <p class="day AkrobatR">
                            {{ $t('ca.第count天', { count: (currentWeek - 1) * weekDays + index + 1 }) }}
                        </p>
                        <p class="date AkrobatR">
                            {{ dayDateFun(detailsData.start_date, (currentWeek - 1) * weekDays + index + 1) }}
                        </p>
                    </div>
                    <span v-else>--</span>
                </div>
            </div>
            <ul>
                <li
                    v-for="(dayItem, dayIndex) in templateList.slice(
                        (currentWeek - 1) * weekDays,
                        currentWeek * weekDays
                    )"
                    :key="dayIndex"
                    :class="{ 'is-empty': (currentWeek - 1) * weekDays + dayIndex + 1 > totalDay }"
                >
                    <templateItem
                        v-for="(workItem, workIndex) in dayItem"
                        :key="workIndex"
                        :item="workItem"
                    />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import templateItem from './template-card.vue'
export default {
    components: {
        templateItem
    },
    props: {
        detailsData: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },
    data() {
        return {
            templateList: [], // 日程列表
            currentWeek: 1, // 当前周
            weekDays: 7, // 默认是7天
            totalDay: 0, // 总天数
        }
    },
    created() {
        this.initFun()
    },
    methods: {
        // 初始化数据
        initFun() {
            this.totalDay = this.dayLengthFun(this.detailsData.start_date, this.detailsData.end_date)
            this.getScheduleData()
        },
        // 获取数据
        async getScheduleData() {
            const params = {
                tenant_id: this.detailsData.tenant_id
            }
            const { code, data } = await this.$server.campScheduleApi(params, this.detailsData.id)
            if (code === 200) {
                this.templateList = data
            }
        },
        // 开始时间-结束时间-第几天 返回 第几天的当前日期
        dayDateFun(start, day) {
            let a = this.$moment(start).valueOf() + 1000 * 3600 * 24 * (day - 1)
            let b = this.$moment(a).format('MM/DD')
            return b
        },
        // 开始时间-结束时间 返回 区间天数
        dayLengthFun(start, end) {
            let a = (this.$moment(end).valueOf() - this.$moment(start).valueOf()) / (1000 * 3600 * 24)
            return a + 1
        },
        pageFun(type) {
            if (type === 'prev') {
                if (this.currentWeek > 1) {
                    --this.currentWeek
                }
            }
            if (type === 'next') {
                if (this.currentWeek * this.weekDays < this.totalDay) {
                    ++this.currentWeek
                }
            }
        },
    },
}
</script>
<style lang="scss" scoped>
div,
ul,
li {
    box-sizing: border-box;
}
.workAge {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
    .title {
        position: relative;
        height: 48px;
        font-size: 16px;
        line-height: 48px;
        text-align: center;
        background: #fff;
        margin-bottom: 2px;
        .page_btn {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 20px;
            top: 0;
            height: 56px;
            .btn {
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                box-sizing: border-box;
                width: 32px;
                height: 32px;
                margin-right: 10px;
                border-radius: 50%;
                .el-button {
                    background: #fff;
                }
            }
        }
    }
    .content {
        height: calc(100% - 50px);
        .day_title_list {
            margin-bottom: 2px;
            display: flex;
            background: #fff;
            box-shadow: 0px 2px 4px 0px #00000014;
            .day_title {
                width: calc(100% / 7);
                padding: 14px 24px;
                height: 68px;
                border-left: 1px solid #E9EDF3;
                .day {
                    margin-bottom: 6px;
                    font-size: 14px;
                    color: #81818a;
                }
                .date {
                    font-size: 22px;
                    color: #81818a;
                    font-weight: 600;
                }
            }
            .day_title:first-child {
                border-left: none;
            }
        }
        ul {
            display: flex;
            height: calc(100% - 78px);
            background: #fff;
            overflow: auto;
            padding-bottom: 28px;
            border-radius: 0px 0px 4px 4px;
            li {
                width: calc(100% / 7);
                border-left: 1px solid #E9EDF3;
                &.is-empty {
                    background: #fff;
                }
            }
            li:first-child {
                border-left: none;
            }
        }
    }
}
</style>
